import UniversityForm from "../../components/UniversityForm/UniversityForm";
const CreateUniversity = () => {

    return (
        <div style={{ marginTop: '3%' }}>
            <UniversityForm type="Add" />
        </div>
    )
}
export default CreateUniversity;